/* eslint-disable @typescript-eslint/no-use-before-define */
import { getDfedsColors } from '@src/common/util/dfedsColors/dfedsColors';
import { getDfedsColorIterator } from '@src/common/util/dfedsColors/dfedsColorIterator';
import { EventType, EventTypeMeta } from '../types';

export const eventSearchEventTypeMap = colorAssignmentFn();

function colorAssignmentFn() {
  const colors = getDfedsColors();
  const colorIterator = getDfedsColorIterator();

  const defaultColorMap = {
    [EventType.providerEnrollment]: {
      label: 'Provider Enrollment',
      color: colors[0],
    },
    [EventType.billingServiceEnrollment]: {
      label: 'Billing Service Enrollment',
      color: colors[1],
    },
    [EventType.passwordChange]: {
      label: 'Password Change',
      color: colors[2],
    },
    [EventType.login]: {
      label: 'Login',
      color: colors[3],
    },
    [EventType.primaryBankChange]: {
      label: 'Primary Bank Change',
      color: colors[4],
    },
    [EventType.altBankChange]: {
      label: 'Alternate Bank Change',
      color: colors[5],
    },
    [EventType.phoneNumberChange]: {
      label: 'Phone Number Change',
      color: colors[6],
    },
    [EventType.mailAddressChange]: {
      label: 'Physical Address Change',
      color: colors[7],
    },
    [EventType.emailChange]: {
      label: 'Email Address Change',
      color: colors[8],
    },
  };

  let eventTypeMap = { ...defaultColorMap };

  return {
    getItem,
    reset,
  };

  function getItem(eventType: EventType): EventTypeMeta {
    // special case for unknown
    if (eventType === EventType.unknown) {
      return { label: '', color: '' };
    }

    const item = eventTypeMap[eventType];
    if (!item) {
      eventTypeMap[eventType] = {
        label: colorIterator.beFriendly(eventType),
        color: colorIterator.getNextColor(eventTypeMap),
      };
    }
    return eventTypeMap[eventType];
  }

  function reset() {
    eventTypeMap = { ...defaultColorMap };
  }
}
